import { Box, styled, Button, Typography, TableCell, TableContainer } from "@mui/material";
import { StyledTableCellBody, StyledTableCellHead } from "../../../components/common/table/style";

export const StyledStatusBadge = styled(Box)(({ bgcolor, color }) => ({
  display: "inline-flex",
  padding: "4px 12px",
  borderRadius: "20px",
  backgroundColor: bgcolor || "#f5f5f5",
  color: color || "#666",
  fontWeight: 700,
  fontSize: "0.75rem",
  textTransform: "uppercase",
  whiteSpace: "nowrap"
}));

export const StyledMiniStatusBadge = styled(Box)(({ bgcolor, color }) => ({
  display: "inline-flex",
  padding: "2px 8px",
  borderRadius: "5px",
  backgroundColor: bgcolor || "#f5f5f5",
  color: color || "#666",
  fontWeight: 700,
  fontSize: "0.65rem",
  textTransform: "uppercase",
  whiteSpace: "nowrap"
}));

export const StyledDetailsBox = styled(Box)(() => ({
  margin: "16px",
  padding: "16px",
  backgroundColor: "#fafafa",
  borderRadius: "8px",
  border: "1px solid #e0e0e0"
}));

export const StyledTimelineHeader = styled(Typography)(({ color }) => ({
  marginBottom: "8px",
  textTransform: "uppercase",
  fontSize: "0.75rem",
  letterSpacing: "0.05em",
  fontWeight: 700,
  color: color || "#1565c0"
}));

export const StyledMonospaceCell = styled(StyledTableCellBody)(() => ({
  fontFamily: "monospace",
  fontSize: "0.85rem"
}));

export const StyledOrderLink = styled(Typography)(() => ({
  fontSize: "0.875rem",
  fontWeight: 700,
  color: "#1565c0",
  cursor: "pointer",
  textDecoration: "underline",
  display: "inline-block"
}));

export const StyledActionBtn = styled(Button)(() => ({
  textTransform: "none",
  borderRadius: "20px",
  borderColor: "#1565c0",
  color: "#1565c0",
  fontWeight: 600,
  "&:hover": {
    borderColor: "#0d47a1",
    backgroundColor: "#e3f2fd"
  }
}));

export const StyledBorderedTableContainer = styled(TableContainer)(() => ({
  border: "1px solid #e0e0e0"
}));

export const StyledTableHeaderCell = styled(StyledTableCellHead)(() => ({
  paddingTop: "8px",
  paddingBottom: "8px",
  fontSize: "0.75rem"
}));

export const StyledTableBodyCell = styled(StyledTableCellBody)(({ fontweight }) => ({
  paddingTop: "8px",
  paddingBottom: "8px",
  fontSize: "0.75rem",
  fontWeight: fontweight || 400
}));

export const StyledFilterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "16px",
  alignItems: "center",
  width: "100%",
  marginBottom: "24px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch"
  }
}));
